module.exports = __webpack_public_path__ + "static/img/nationalD.b431f93c.png";